export const randomUUID = (): string => {
  return window.crypto.randomUUID();
};
